import React from 'react';

export const HandIcon = () => (
  <svg width="32" height="45" viewBox="0 0 32 45" fill="none">
    <path
      opacity="0.2"
      d="M11.75 1.75C16.9967 1.75 21.25 6.00329 21.25 11.25C21.25 13.7447 20.2868 16.0126 18.7139 17.707C18.2561 17.1252 17.5477 16.75 16.75 16.75C15.3693 16.75 14.25 17.8693 14.25 19.25V13.25C14.25 11.8693 13.1307 10.75 11.75 10.75C10.3693 10.75 9.25 11.8693 9.25 13.25V20.415C5.21649 19.3174 2.25 15.6312 2.25 11.25C2.25 6.00329 6.50329 1.75 11.75 1.75Z"
      fill="#77EDFF"
    />
    <path
      d="M9.25 27.75L6.88872 31.092C5.96665 32.317 6.05099 34.0224 7.08942 35.1512L13.1314 41.7183C13.7363 42.3757 14.589 42.75 15.4841 42.75C17.2185 42.75 20.055 42.75 22.8629 42.75C26.6952 42.75 29.25 39.5682 29.25 36.3864C29.25 36.3864 29.25 25.4773 29.25 22.75"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.25 23.75C24.25 23.75 24.25 23.531 24.25 22.75C24.25 18.75 29.25 18.75 29.25 22.75"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.25 23.75C19.25 23.75 19.25 22.3121 19.25 20.75C19.25 16.75 24.25 16.75 24.25 20.75C24.25 21.1405 24.25 22.3595 24.25 22.75C24.25 23.5311 24.25 23.75 24.25 23.75"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 23.75C14.25 23.75 14.25 21.4507 14.25 19.5974C14.25 15.8009 19.25 15.8009 19.25 19.5974C19.25 19.5974 19.25 20.5318 19.25 20.9025C19.25 22.3851 19.25 23.75 19.25 23.75"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 23.6731C14.25 23.6731 14.25 21.437 14.25 19.6346C14.25 17.7633 14.25 15.0949 14.25 13.1714C14.25 11.8332 13.1307 10.75 11.75 10.75C10.3693 10.75 9.25 11.8348 9.25 13.1731V26.9038V31.75"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowIcon = () => (
  <svg width="11" height="20" viewBox="0 0 10.2235 19.1316" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.51769 18.8252C8.9026 19.2262 9.54722 19.236 9.93805 18.8407C10.3147 18.4598 10.3192 17.8482 9.94833 17.4617L2.35389 9.5488L3.23488 8.63083L3.22987 8.63621L9.91337 1.67275C10.2802 1.29051 10.2803 0.686934 9.91347 0.304645C9.52473 -0.100503 8.87827 -0.102039 8.4894 0.30299C6.33988 2.54185 2.33288 6.71639 0.277887 8.85785C-0.0933144 9.24467 -0.0922641 9.85422 0.278853 10.2411C0.920414 10.91 1.67949 11.7006 8.51769 18.8252Z"
      fill="white"
      transform="rotate(180 5.11175 9.5658)"
    />
  </svg>
);
